/*
 *  Copyright (c) 2024. Rapida
 *
 *  Permission is hereby granted, free of charge, to any person obtaining a copy
 *  of this software and associated documentation files (the "Software"), to deal
 *  in the Software without restriction, including without limitation the rights
 *  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 *  copies of the Software, and to permit persons to whom the Software is
 *  furnished to do so, subject to the following conditions:
 *
 *  The above copyright notice and this permission notice shall be included in
 *  all copies or substantial portions of the Software.
 *
 *  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 *  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 *  THE SOFTWARE.
 *
 *  Author: Prashant <prashant@rapida.ai>
 *
 */
import { Source, SourceMap } from "@/rapida/clients/protos/common_pb";

export enum RapidaSource {
  WEB_PLUGIN = "web-plugin",
  DEBUGGER = "debugger", // no proto value
  SDK = "sdk",
  PHONE_CALL = "phone-call",
  WHATSAPP = "whatsapp",
}

// Only the sources that exist in the protobuf Source enum
type MappedRapidaSource =
  | RapidaSource.WEB_PLUGIN
  | RapidaSource.DEBUGGER
  | RapidaSource.SDK
  | RapidaSource.PHONE_CALL
  | RapidaSource.WHATSAPP;

const SourceMapping: Record<MappedRapidaSource, number> = {
  [RapidaSource.WEB_PLUGIN]: Source.WEB_PLUGIN,
  [RapidaSource.SDK]: Source.SDK,
  [RapidaSource.DEBUGGER]: Source.DEBUGGER,
  [RapidaSource.PHONE_CALL]: Source.PHONE_CALL,
  [RapidaSource.WHATSAPP]: Source.WHATSAPP,
};

export function GetProtoSource(
  source: RapidaSource
): SourceMap[keyof SourceMap] {
  const mappedSource = SourceMapping[source as MappedRapidaSource];
  if (mappedSource === undefined) {
    console.warn(`Invalid RapidaSource: ${source}`);
  }
  return Source.SDK;
}
